import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedWorkspace:''
};

const workSpaceSlice = createSlice({
  name: 'workSpace',
  initialState,
  reducers: {
    setWorkspaceData: (state, action) => {
      return {
        ...state,
        ...action.payload,
        showworkspaceInitialState: true,
      };
    },
    setWorkspaceIsLoading(state, action) {
      state.isloading = action?.payload?.isloading;
    },
    resetWorkspace: ()=>initialState
  },
});

const { reducer, actions } = workSpaceSlice;

export const { setWorkspaceData,resetWorkspace } = actions;
export default reducer;
